module.exports = __webpack_public_path__ + "img/introducePageSeven_show_five.1ddb3237.jpg";